import React from 'react';
import CustomModal from 'src/components/customModal/CustomModal';
import OtpVerificationForm from './OtpVerficationForm';
import styles from "./account.module.scss"

interface IOtpVerificationModal {
    displayOtpModal: boolean;
    setDisplayOtpModal: (boolean) => void;
    handleOtpVerification: (values, setSubmitting) => void;
    resendOtp: (setSubmitting) => void;
    userEmail: string;
    otpExpiry: string;
    otpModalDescription: string
}

const OtpVerificationModal: React.FC<IOtpVerificationModal> = ({
    displayOtpModal,
    setDisplayOtpModal,
    handleOtpVerification,
    resendOtp,
    userEmail,
    otpExpiry,
    otpModalDescription
}) => {

    const maskEmail = (email: string): string => {
        if (!email?.length) return;
        const [localPart, domain] = email.split('@');
        if (localPart.length <= 2) {
            return `${localPart[0]}***@${domain}`;
        }
        return `${localPart[0]}${'*'.repeat(localPart.length - 2)}${localPart.slice(
            -1,
        )}@${domain}`;
    };

    return (
        <CustomModal
            showModal={displayOtpModal}
            title={''}
            closeModal={() => setDisplayOtpModal(false)}
            modalBodyClass="text-center"
            headerClasss='justify-content-center pt-5'
        >
            <h3 className={` mt-4 mt-md-0 mb-4 ${styles.otpModalH3}`}>
                {
                    otpModalDescription ?
                        otpModalDescription
                        :
                        `We have sent a 6-digit verification code to ${maskEmail(userEmail)}.`
                }
            </h3>
            <OtpVerificationForm
                handleOtpVerification={handleOtpVerification}
                resendOtp={resendOtp}
                userEmail={userEmail}
                otpExpiry={otpExpiry}
            />
        </CustomModal>
    );
};

export default OtpVerificationModal;
